import React, { useContext } from 'react';

import { ModalContext } from '@spa/shared/contexts/modal';
import CreateOfferAlertModal from '@spa/shared/components/Modals/CreateOfferAlertModal';
import FiltersModal from '@spa/shared/components/Search/MobileFiltersModals/FiltersModal';
import WishlistModal from '@spa/shared/components/Modals/WishlistModal';

export const modalIds = {
  WISHLIST: 'wishlist',
  CREATE_OFFER_ALERT: 'create-offer-alert',
  FILTERS_MODAL: 'filters-modal'
};

const ModalDisplayer = () => {
  const { state: { modalId } = {}, dispatch } = useContext(ModalContext);

  switch (modalId) {
    case modalIds.WISHLIST:
      return <WishlistModal onClose={() => dispatch({ type: 'hide' })} />;
    case modalIds.CREATE_OFFER_ALERT:
      return <CreateOfferAlertModal onClose={() => dispatch({ type: 'hide' })} />;
    case modalIds.FILTERS_MODAL:
      return <FiltersModal onClose={() => dispatch({ type: 'hide' })} />;
    default:
      return null;
  }
};

export default ModalDisplayer;
